export async function uploadImage(api, file) {
  if (!file) {
    return {}
  }

  const response = await api('constructor-new/upload-image', file)

  return response.result
}
